import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import Axios from "axios";
import AccessDenied from "../components/AccessDenied";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  MDBCardTitle,
  MDBCardText,
  MDBTooltip,
  MDBCardHeader,
  MDBCardBody,
  MDBCard,
  MDBCardFooter,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBModalHeader,
  MDBModalBody,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
} from "mdbreact";
import AddEditItem from "./AddEditItem";
import AddEditPackage from "./AddEditPackage";
import PackageInclusion from "./PackageInclusion";

const PackagesTable = (props) => {
  const TitleBar = () => {
    return (
      <React.Fragment>
        <h5
          style={{
            fontFamily: "Roboto",
            fontWeight: "600",
            fontSize: "1em",
            padding: "0",
          }}
          className="brown-text h5-responsive pt-4"
        >
          {props.title}
        </h5>

        <p className="small">{props.description}</p>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <MaterialTable
        title={<TitleBar></TitleBar>}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        columns={[
          { title: "", field: "code", hidden: true },

          { title: "Package", field: "description" },

          { title: "Package Cost", field: "sellingprice" },
        ]}
        data={props.rows}
        //   options={{
        //     search: true,
        //     actionsColumnIndex: -1
        //     ,filtering:true
        //   }}

        options={{
          search: true,
          actionsColumnIndex: -1,
          filtering: true,
          detailPanelType: "single",

          cellStyle: {
            width: "100%",
            // paddingLeft: "0px",
          },
        }}
        detailPanel={[
          {
            icon: () => <MDBIcon icon="edit" className="brown-text" />,
            openIcon: () => (
              <MDBIcon icon="chevron-down" className="red-text" />
            ),
            tooltip: "Package Details",
            render: (rowData) => {
              return (
                <React.Fragment>
                  <AddEditPackage
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                    itemcode={rowData.code}
                    apiServerHybrid={props.apiServerHybrid}
                    toggleModal={props.toggleAddEdit}
                    refreshGrid={props.refreshGrid}
                  />
                </React.Fragment>
              );
            },
          },

          {
            icon: () => <MDBIcon icon="list" className="purple-text" />,
            openIcon: () => (
              <MDBIcon icon="chevron-down" className="red-text" />
            ),
            tooltip: "Package Inclusion",
            render: (rowData) => {
              return (
                <React.Fragment>
                  <PackageInclusion
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                    itemcode={rowData.code}
                    apiServerHybrid={props.apiServerHybrid}
                    toggleModal={props.toggleAddEdit}
                    refreshGrid={props.refreshGrid}
                    parentcode={rowData.code}
                  />
                </React.Fragment>
              );
            },
          },
        ]}
      />
    </React.Fragment>
  );
};

//
export default PackagesTable;
